export const createEstateUrlPath = (
  localePrefix: string,
  countrySlug?: string,
  estateSlug?: string,
  removeRealEstate?: boolean
): string => {
  return removeRealEstate
    ? `${localePrefix}/${countrySlug}/${estateSlug}`
    : `${localePrefix}/real-estate/${countrySlug}/${estateSlug}`;
};

export default createEstateUrlPath;
